import type { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import type {
  HotelConstraintQL,
  OwnStayIngredientAdapter,
} from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';

import { getBaseConstraintQL } from '../baseIngredientAdapter';

import { adaptActivityIngredientToItinerarySearchCriteria } from './activityIngredientItinerarySearchAdapter';

export function adaptOwnStayIngredientToItinerarySearchCriteria(
  ingredient: OwnStayIngredient
): OwnStayIngredientAdapter {
  const constraint: HotelConstraintQL = getBaseConstraintQL(
    ingredient.searchTerm
  );

  return {
    ingredientType: IngredientType.OwnStay,
    ingredientId: ingredient.ingredientId,
    subIngredients: ingredient.subIngredients.map(
      adaptActivityIngredientToItinerarySearchCriteria
    ),
    numberOfNights: ingredient.numberOfNights,
    constraint,
  };
}
